// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a44a976f","239":"2a245fcc","453":"a7a43dd6","732":"9e3f8f2f"}[chunkId] + ".chunk.js";
};